import {
  algoliasearch,
  type Algoliasearch,
  type GetObjectsParams,
  type GetRecommendationsParams,
  type RecommendClient,
  type SearchForFacetValuesProps,
  type SearchMethodParams,
  type SearchSingleIndexProps,
} from 'algoliasearch';
import geoCountry from 'utils/geo-country';
import userToken from 'utils/user-token';
import { isbot } from 'isbot';

class Algolia {
  static readonly COLLECTIONS = `${theme.integrations.algolia.prefix}-collections`;

  static readonly PAGES = `${theme.integrations.algolia.prefix}-pages`;

  static readonly PRODUCTS = `${theme.integrations.algolia.prefix}-products`;

  static readonly VARIANTS = `${theme.integrations.algolia.prefix}-variants`;

  static readonly QUERY_SUGGESTIONS = `${theme.integrations.algolia.prefix}-query-suggestions`;

  private client: Algoliasearch;

  private recommendClient: RecommendClient;

  constructor() {
    this.client = algoliasearch(
      theme.integrations.algolia.applicationId,
      theme.integrations.algolia.searchKey,
    );

    this.recommendClient = this.client.initRecommend();
  }

  searchSingle(data: SearchSingleIndexProps) {
    return this.client.searchSingleIndex(data, {
      queryParameters: {
        userToken: userToken(),
      },
    });
  }

  searchMultiple(data: SearchMethodParams) {
    return this.client.search(data, {
      queryParameters: {
        userToken: userToken(),
      },
    });
  }

  async getRecommendations(data: GetRecommendationsParams) {
    if (isbot(navigator.userAgent)) {
      return null;
    }

    const country = await geoCountry();

    switch (country) {
      case 'US':
      case 'CN':
        return null;

      default:
        return this.recommendClient.getRecommendations(data, {
          queryParameters: {
            userToken: userToken(),
          },
        });
    }
  }

  searchForFacetValues(data: SearchForFacetValuesProps) {
    return this.client.searchForFacetValues(data, {
      queryParameters: {
        userToken: userToken(),
      },
    });
  }

  getObjects(data: GetObjectsParams) {
    return this.client.getObjects(data, {
      queryParameters: {
        userToken: userToken(),
      },
    });
  }
}

export default Algolia;
